import React from 'react';
import ActionButton from '../ActionButton';
import style from './style.module.css';
import {IDropDownHeader} from "./types";
import { ButtonColors } from 'design-v2/common/ActionButton/types';

const NS = 'DropDownHeader';

export default function DropDownHeader({title, handleCancel, handleSave, buttonDisable, cancelText, saveText, isHideSave = false, isColorOverride = false}: IDropDownHeader) {
  return (
    <div className={style.root} >
      <ActionButton variant={'secondary'} size={'regular'} text={cancelText || 'Cancel'} handleClick={handleCancel}/>
      <span className={style.title}>{title}</span>
      <ActionButton variant={'primary'} size={'regular'} text={saveText || 'Save'} handleClick={handleSave} isHide={isHideSave} disabled={buttonDisable || isHideSave} colorOverride={isColorOverride ? ButtonColors.WARNING : null}/>
    </div>
  )
}
